import Text from 'components/Text/Text';
import React, { useContext, useEffect } from 'react';
import {
	ICreateModifierGroupsContext,
	CreateModifierGroupsContext,
} from '../../../../../createModifierGroupsState/createModifierGroupsContext';
import CustomerSelect from './components/CustomerSelect';
import RestaurantsMultipleSelect from './components/RestaurantsMultipleSelect/RestaurantsMultipleSelect';
import CategoryMultipleSelect from './components/CategoryMultipleSelect/CategoryMultipleSelect';
import SubcategoryMultipleSelect from './components/SubcategoryMultipleSelect/SubcategoryMultipleSelect';
import DishesMultipleSelect from './components/DishesMultipleSelect/DishesMultipleSelect';
import NameModifierGroupInput from './components/NameModifierGroupInput';
import BtnBlock from './components/BtnBlock';
import { Form } from 'antd';
import { preventDefaultForEnterKey } from 'utils/helpers';
import style from './InputFields.module.scss';

const InputFields: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		setDataForSubmit,
		setIDCustomer,
		setFetchedCustomers,
		setIDsRestaurant,
		setFetchedRestaurants,
		setIDsCategories,
		updateCategories,
		setFetchedCategories,
		setIDsSubcategories,
		updateSubcategories,
		setFetchedSubcategories,
		setIDsDishes,
		updateDishes,
		setFetchedDishes,
		changeNameOfModifierGroup,
		IDSelectedCustomer,
		IDsSelectedRestaurant,
		IDsSelectedCategories,
		IDsSelectedSubcategories,
		IDsSelectedDishes,
		nameOfModifierGroup,
		translations,
		defaultCustomerLanguage,
	} = useContext<ICreateModifierGroupsContext>(CreateModifierGroupsContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({ IDSelectedCustomer });
		form.setFieldsValue({ IDsSelectedRestaurant });
		form.setFieldsValue({ IDsSelectedCategories });
		form.setFieldsValue({ IDsSelectedSubcategories });
		form.setFieldsValue({ IDsSelectedDishes });
		form.setFieldsValue({ nameOfModifierGroup });
	}, [
		IDSelectedCustomer,
		IDsSelectedRestaurant,
		IDsSelectedCategories,
		IDsSelectedSubcategories,
		IDsSelectedDishes,
		nameOfModifierGroup,
	]);

	const submit = async () => {
		const defaultTranslationIsEmpty =
			translations.find((translation) => translation.languageId === defaultCustomerLanguage?.id)?.name === '';
		if (defaultTranslationIsEmpty) {
			changeTypeOfModalWindow('defaultTranslationIsEmpty');
			return;
		}

		setDataForSubmit({
			name: nameOfModifierGroup,
			customerId: IDSelectedCustomer || '',
			restaurantIds: IDsSelectedRestaurant,
			dishIds: IDsSelectedDishes,
			modifierIds: [],
			translations,
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	return (
		<div className={style.container} data-test="InputFields">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="mainInfoHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<CustomerSelect setIDCustomer={setIDCustomer} setFetchedCustomers={setFetchedCustomers} />
					<RestaurantsMultipleSelect
						IDsSelectedRestaurant={IDsSelectedRestaurant}
						IDSelectedCustomer={IDSelectedCustomer}
						setIDsRestaurant={setIDsRestaurant}
						setFetchedRestaurants={setFetchedRestaurants}
					/>
					<NameModifierGroupInput changeNameOfModifierGroup={changeNameOfModifierGroup} />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="categoriesSubcategoriesDishesHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<CategoryMultipleSelect
						setIDsCategories={setIDsCategories}
						setFetchedCategories={setFetchedCategories}
						updateCategories={updateCategories}
						IDsSelectedRestaurant={IDsSelectedRestaurant}
						IDsSelectedCategories={IDsSelectedCategories}
					/>
					<SubcategoryMultipleSelect
						setIDsSubcategories={setIDsSubcategories}
						setFetchedSubcategories={setFetchedSubcategories}
						updateSubcategories={updateSubcategories}
						IDsSelectedCategories={IDsSelectedCategories}
						IDsSelectedSubcategories={IDsSelectedSubcategories}
					/>
					<DishesMultipleSelect
						setIDsDishes={setIDsDishes}
						setFetchedDishes={setFetchedDishes}
						updateDishes={updateDishes}
						IDsSelectedDishes={IDsSelectedDishes}
						IDsSelectedSubcategories={IDsSelectedSubcategories}
						IDsSelectedRestaurant={IDsSelectedRestaurant}
					/>
				</div>
				<BtnBlock />
			</Form>
		</div>
	);
};

export default InputFields;
